"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Qr;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Qr(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "QR"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "qr"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-5",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M15.234,42.346H40.067a2.5,2.5,0,0,0,2.5-2.5V15.013a2.5,2.5,0,0,0-2.5-2.5H15.234a2.5,2.5,0,0,0-2.5,2.5V39.846A2.5,2.5,0,0,0,15.234,42.346Zm2.5-24.833H37.567V37.346H17.734Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    className: "cls-1",
    x: "24.651",
    y: "24.429",
    width: 6,
    height: 6,
    rx: "1.5",
    ry: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    className: "cls-1",
    x: "24.651",
    y: "69.571",
    width: 6,
    height: 6,
    rx: "1.5",
    ry: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    className: "cls-1",
    x: "69.349",
    y: "24.429",
    width: 6,
    height: 6,
    rx: "1.5",
    ry: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    className: "cls-1",
    x: "69.349",
    y: "69.571",
    width: 6,
    height: 6,
    rx: "1.5",
    ry: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M84.766,12.513H59.933a2.5,2.5,0,0,0-2.5,2.5V39.846a2.5,2.5,0,0,0,2.5,2.5H84.766a2.5,2.5,0,0,0,2.5-2.5V15.013A2.5,2.5,0,0,0,84.766,12.513Zm-2.5,24.833H62.433V17.513H82.266Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M40.067,57.654H15.234a2.5,2.5,0,0,0-2.5,2.5V84.987a2.5,2.5,0,0,0,2.5,2.5H40.067a2.5,2.5,0,0,0,2.5-2.5V60.154A2.5,2.5,0,0,0,40.067,57.654Zm-2.5,24.833H17.734V62.654H37.567Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M74.725,60.154a2.5,2.5,0,0,0-2.5-2.5H59.933a2.5,2.5,0,0,0-2.5,2.5V72.571a2.5,2.5,0,0,0,5,0V62.654h9.792A2.5,2.5,0,0,0,74.725,60.154Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M84.766,70.071a2.5,2.5,0,0,0-2.5,2.5v9.916H72.225a2.5,2.5,0,0,0,0,5H84.766a2.5,2.5,0,0,0,2.5-2.5V72.571A2.5,2.5,0,0,0,84.766,70.071Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,81.346a2.5,2.5,0,0,0-2.5,2.5v.92a2.5,2.5,0,1,0,5,0v-.92A2.5,2.5,0,0,0,50,81.346Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,68.571a2.5,2.5,0,0,0-2.5,2.5v3.708a2.5,2.5,0,0,0,5,0V71.071A2.5,2.5,0,0,0,50,68.571Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,54.846a2.5,2.5,0,0,0-2.5,2.5V63.1a2.5,2.5,0,0,0,5,0v-5.75A2.5,2.5,0,0,0,50,54.846Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,43.346a2.5,2.5,0,0,0,2.5-2.5V25.929a2.5,2.5,0,0,0-5,0V40.846A2.5,2.5,0,0,0,50,43.346Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,21.346a2.5,2.5,0,0,0,2.5-2.5V15.234a2.5,2.5,0,1,0-5,0v3.612A2.5,2.5,0,0,0,50,21.346Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M15.234,52.5h4.92a2.5,2.5,0,0,0,0-5h-4.92a2.5,2.5,0,1,0,0,5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M28.221,47.5a2.5,2.5,0,0,0,0,5h.708a2.5,2.5,0,1,0,0-5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M54.654,47.5H40.9a2.5,2.5,0,1,0,0,5h13.75a2.5,2.5,0,0,0,0-5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M73.07,52.5a2.5,2.5,0,0,0,0-5H63.154a2.5,2.5,0,1,0,0,5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M84.766,47.5H79.154a2.5,2.5,0,0,0,0,5h5.612a2.5,2.5,0,1,0,0-5Z"
  })))));
}